import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["totalSteps", "activeStep", "titles", "isVertical", "children", "status"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Stepper/Stepper.js",
  _this = this;
import React from 'react';
import CompletedIcon from '@dls/assets/icons/Completed';
import useDevice from '../../core/hooks/useDevice';
import { useTheme } from '../../core/ThemeProvider';
import { testIdProps } from '../../helpers';
import { ActiveBorder, CircleWrapper, getCircleText, Line, StepContainer, Title, TitleWrapper, VerticalWrapper, Wrapper } from './style';
var MAX_STEP = 5;
var Step = function Step(_ref) {
  var current = _ref.current,
    active = _ref.active,
    title = _ref.title,
    isFirst = _ref.isFirst,
    isLast = _ref.isLast,
    visible = _ref.visible,
    isVertical = _ref.isVertical,
    status = _ref.status;
  var _useTheme = useTheme(),
    theme = _useTheme.theme;
  var _useDevice = useDevice(),
    isMobile = _useDevice.isMobile;
  var isBeforeActive = status ? status === 'completed' && current !== active : current < active;
  var isActive = current === active;
  var isAfterActive = !isBeforeActive && !isActive;
  var CircleText = getCircleText(isActive);
  var circleColor = isAfterActive ? theme.cl_ter_l3 : theme.cl_white;
  var circleBgColor = isBeforeActive ? theme.cl_white : isActive ? theme.cl_sec_d2 : theme.cl_ter_l5;
  var lineColor = isAfterActive || isActive ? theme.cl_ter_l5 : theme.cl_ter_l3;
  return /*#__PURE__*/React.createElement(StepContainer, {
    isLast: isLast,
    isVertical: isVertical,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 5
    }
  }, visible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CircleWrapper, {
    isVertical: isVertical,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(ActiveBorder, {
    isActive: isActive,
    isVertical: isVertical,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(CircleText, {
    bgColor: circleBgColor,
    color: circleColor,
    "data-testid": "stepId-".concat(current),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 15
    }
  }, (isAfterActive || isActive) && current, isBeforeActive && /*#__PURE__*/React.createElement(CompletedIcon, {
    color: theme.cl_ter_l3,
    size: isMobile ? theme.space_6 : theme.space_8,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 19
    }
  }))), !isVertical && /*#__PURE__*/React.createElement(Line, {
    "data-testid": "lineId-".concat(current),
    color: lineColor,
    isActive: isActive,
    isFirst: isFirst,
    isLast: isLast,
    isVertical: isVertical,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 15
    }
  })), !isVertical && title && !isMobile && /*#__PURE__*/React.createElement(Title, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 49
    }
  }, title), isVertical && /*#__PURE__*/React.createElement(Line, {
    "data-testid": "lineId-".concat(current),
    color: lineColor,
    isActive: isActive,
    isFirst: isFirst,
    isLast: isLast,
    isVertical: isVertical,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 13
    }
  })));
};
var Stepper = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var totalSteps = props.totalSteps,
    activeStep = props.activeStep,
    titles = props.titles,
    isVertical = props.isVertical,
    children = props.children,
    status = props.status,
    rest = _objectWithoutProperties(props, _excluded);
  var stepperChildren = React.Children.toArray(children);
  var NoOfSteps = totalSteps && stepperChildren.length === 0 && totalSteps !== stepperChildren.length && isVertical ? totalSteps : stepperChildren.length;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    isVertical: isVertical
  }, testIdProps(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 114,
      columnNumber: 5
    }
  }), !isVertical ? _toConsumableArray(Array(MAX_STEP)).map(function (_, index) {
    return /*#__PURE__*/React.createElement(Step, {
      key: index,
      current: index + 1,
      active: activeStep,
      title: titles ? titles[index] : null,
      isFirst: index === 0,
      isLast: index + 1 === totalSteps,
      visible: index + 1 <= totalSteps,
      isVertical: isVertical,
      ref: ref,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 117,
        columnNumber: 13
      }
    });
  }) : _toConsumableArray(Array(NoOfSteps)).map(function (_, index) {
    return /*#__PURE__*/React.createElement(VerticalWrapper, {
      key: index,
      isLast: index + 1 === NoOfSteps,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 130,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Step, {
      key: index,
      current: index + 1,
      active: activeStep,
      title: titles ? titles[index] : null,
      isFirst: index === 0,
      isLast: index + 1 === NoOfSteps,
      visible: index + 1 <= NoOfSteps,
      isVertical: isVertical,
      status: status ? status[index] : null,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 131,
        columnNumber: 15
      }
    }), /*#__PURE__*/React.createElement(TitleWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 144,
        columnNumber: 17
      }
    }, stepperChildren && stepperChildren[index] ? stepperChildren[index] : titles && titles[index] && /*#__PURE__*/React.createElement(Title, {
      isVertical: isVertical,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 149,
        columnNumber: 25
      }
    }, titles[index])));
  }));
});
Stepper.defaultProps = {
  totalSteps: MAX_STEP
};
Stepper.displayName = 'Stepper';
export default Stepper;